import React, { useEffect, useState } from 'react';

import moment from 'moment-jalaali';
import { useAtom } from 'jotai';
import { selectedDepartmentAtom } from '../shared/selected.department';
import { selectedTurnItem } from '../shared/selected.turn.items';
import { selectedTurnBase } from '../shared/selected.turn.base';
import { fetchDoctors } from '../adapaters/fetchDoctors';
import { nearestTurnAtom } from '../shared/nearest.turn';
import { selectedDoctorAtom } from '../shared/selected.doctor';

const useFetchDoctors = (turnBaseData, steps) => {
  const [doctors, getDoctors] = useState(null);

  const [selectedTurn] = useAtom(selectedTurnItem);
  const [turnBase] = useAtom(selectedTurnBase);
  const [selectedDepartment] = useAtom(
    selectedDepartmentAtom
  );
  const [, setNearestTurn] = useAtom(nearestTurnAtom);

  const [, setSelectedDoctor] = useAtom(selectedDoctorAtom);

  useEffect(() => {
    if (steps === 2) {
      getDoctors();
    }
  }, [steps]);

  // console.log('selectedTurn->', selectedTurn);

  useEffect(() => {
    if (doctors && doctors?.length === 1) {
      setSelectedDoctor(doctors[0]);
    }
  }, [doctors]);

  useEffect(() => {
    getDoctors();

    if (turnBaseData) {
      const api_data = {
        idService:
          turnBase === 'speciality' ? 0 : selectedTurn?.id,
        idSpeciality:
          turnBase === 'service' ? 0 : selectedTurn?.id,
        startDate: moment().format('YYYY/MM/DD'),
        endDate: moment()
          .add(4, 'months')
          .format('YYYY/MM/DD'),
        topRecord: 30,
        idDarmangah: selectedDepartment?.Id,
      };

      if (
        api_data !== null &&
        api_data.idService !== undefined &&
        api_data.idSpeciality !== undefined
      ) {
        fetchDoctors(getDoctors, api_data, setNearestTurn);
      }
    }
  }, [selectedTurn]);

  return doctors;
};

export default useFetchDoctors;
